import { getParameter } from '@busuu/query-params';
import { PRICING_DEFAULT_COUNTRY } from '@busuu/pricing';
import { COUNTRIES } from '@busuu/countries';

var PLATFORMS = {
    WEB: 'web',
    ANDROID: 'android',
    IOS: 'ios',
};
var QUERY_PARAMETERS = {
    PLATFORM: 'platform',
    PLATFORM_COUNTRY: 'platformCountry',
    CLOSE_LINK: 'closeLink',
    PURCHASE_LINK: 'purchaseLink',
    RESTORE_LINK: 'restoreLink',
};
var DEFAULT_DEEPLINK_CLOSE_URL = 'busuupurchase://type=close';
var DEFAULT_DEEPLINK_PURCHASE_URL = 'busuupurchase://type=purchase';
var DEFAULT_DEEPLINK_RESTORE_PURCHASE_URL = 'busuupurchase://type=restore';
var ERROR_PAGE_URL = '/products/error';
var PROVIDERS = {
    GOOGLE: 'google',
    APPLE: 'apple',
    STRIPE: 'stripe',
    BRAINTREE: 'braintree',
};

// Utils
/**
 * Function that returns the platform country based on url query
 * Default to 'US'
 * @returns {string}
 */
var getPlatformCountry = function () {
    var platformCountry = getParameter(QUERY_PARAMETERS.PLATFORM_COUNTRY);
    if (typeof platformCountry === 'string' && platformCountry.toUpperCase() in COUNTRIES) {
        return platformCountry;
    }
    return PRICING_DEFAULT_COUNTRY;
};
var isValidWebviewPlatform = function (platform) {
    return typeof platform === 'string' && platform.toUpperCase() in PLATFORMS;
};
/**
 * Function that returns the platform based on url query
 * Default to 'web'
 * @returns {string}
 */
var getWebviewPlatform = function () {
    var platform = getParameter(QUERY_PARAMETERS.PLATFORM);
    if (isValidWebviewPlatform(platform)) {
        return platform;
    }
    return PLATFORMS.WEB;
};
/**
 * Function that checks if user is inside webview based on "platform" url query
 * @returns {Boolean}
 */
var isWebView = function () {
    var platform = getWebviewPlatform();
    return Boolean(platform && platform !== PLATFORMS.WEB);
};
/**
 * Function that returns a "close page" deeplink
 * @returns {string}
 */
var getCloseDeeplink = function () {
    var closeLink = getParameter(QUERY_PARAMETERS.CLOSE_LINK);
    if (typeof closeLink === 'string') {
        return closeLink;
    }
    return DEFAULT_DEEPLINK_CLOSE_URL;
};
/**
 * Function that returns a "purchase" deeplink
 * In case productId or offerId are not defined send to error page
 * @param {number} productId? Plan ID
 * @param {number} offerId? Plan discount ID
 * @param {boolean} isFreeTrial Does active plan have a free trial
 * @returns {string}
 */
var getPurchaseDeeplink = function (productId, offerId, isFreeTrial) {
    var purchaseLink = getParameter(QUERY_PARAMETERS.PURCHASE_LINK);
    if (productId) {
        var deeplinkPurchaseBase = typeof purchaseLink === 'string' ? purchaseLink : DEFAULT_DEEPLINK_PURCHASE_URL;
        var deeplinkProductId = "&product_id=" + productId;
        var deeplinkOfferId = offerId ? "&offer_id=" + offerId : '';
        var deeplinkFreeTrial = "&free_trial=" + isFreeTrial.toString();
        var deeplink = "" + deeplinkPurchaseBase + deeplinkProductId + deeplinkOfferId + deeplinkFreeTrial;
        return deeplink;
    }
    throw new Error("Purchase Deeplink Error");
};
/**
 * Function that returns a "restore purchase" deeplink
 * @returns {string}
 */
var getRestorePurchaseDeeplink = function () {
    var restoreLink = getParameter(QUERY_PARAMETERS.RESTORE_LINK);
    if (typeof restoreLink === 'string') {
        return restoreLink;
    }
    return DEFAULT_DEEPLINK_RESTORE_PURCHASE_URL;
};
/**
 * Gets data necessary for showing mobile prices and making purchases via webview
 * @param {Price} plan Plan object
 * @returns {ProvidersData | null}
 */
var getMobileProvidersData = function (plan) {
    var mobileProviderPlan = plan.providers_data.find(function (provider) { return provider.provider_name === PROVIDERS.APPLE || provider.provider_name === PROVIDERS.GOOGLE; });
    return mobileProviderPlan || null;
};

export { DEFAULT_DEEPLINK_CLOSE_URL, DEFAULT_DEEPLINK_PURCHASE_URL, DEFAULT_DEEPLINK_RESTORE_PURCHASE_URL, ERROR_PAGE_URL, PLATFORMS, PROVIDERS, QUERY_PARAMETERS, getCloseDeeplink, getMobileProvidersData, getPlatformCountry, getPurchaseDeeplink, getRestorePurchaseDeeplink, getWebviewPlatform, isWebView };
//# sourceMappingURL=index.esm.js.map
